import Image1 from "../../assets/testimonial4.jpg";
import Image2 from "../../assets/testimonial2.jpg";
import Image3 from "../../assets/testimonial1.jpg";
import Image4 from "../../assets/testimonial3.jpg";

export const Data = [
    {
        id: 1, 
        image: Image1,
        title: "Jhon Doe",
        description: "A really good job,all aspects of the project were followed step by step and with good results.",
    },

    {
        id: 2, 
        image: Image2,
        title: "Harry Clinton",
        description:"I'm blown away by the website you've created for us! The design is modern, and the functionality is seamless.",
        
    },

    {
        id: 3, 
        image: Image3,
        title: "Sara Cill",
        description:"OLADAPO AYOMIDE has been an absolute pleasure to work with. Their web development skills are exceptional. You've exceeded our expectations.",
         
    },

    {
        id: 4, 
        image: Image4,
        title: "Daniella Florio",
        description:"Oladapo, I was impressed by the attention to detail and the timely completion of the project..",
         
    },
];